import React from 'react'; // eslint-disable-line
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _actions from '../../actions';
import i18n from '../../i18n';
import HorizontalFormContainer from '../../components/forms/HorizontalFormContainer';
import OnOffSwitch from '../../components/forms/OnOffSwitch';
import ShelbyIcon from '../../assets/images/shelby-next@3x.png';
import F1GoIcon from '../../assets/images/f-one-go@3x.png';
import SCCRMIcon from '../../assets/images/sc-crm@3x.png';
import ETIcon from '../../assets/images/et-plus@3x.png';
import COOnlineIcon from '../../assets/images/co-online@3x.png';
import ElexioIcon from '../../assets/images/elexio-community@3x.png';
import Exclamation from '../../components/svg/Exclamation';
import SuccessCheck from '../../components/svg/SuccessCheck';
import PageBreak from '../../components/structure/PageBreak';

class ChmsIntegration extends React.Component {
    constructor(props) {
        super(props);
        this.updateVersionFromEvent = this.updateVersionFromEvent.bind(this);
        this.learnMore = this.learnMore.bind(this);
    }

    updateVersionFromEvent(evt) {
        const version = this.props.versions.select;
        const fieldName = evt.target.name;
        let changedValue = evt.target.value;

        if (evt.target.type === 'checkbox') {
            changedValue = evt.target.checked;
        }
        version[fieldName] = changedValue;
        this.props.actions.updateProjectVersionbyParameter(
            this.props.versions.select.projectId,
            fieldName,
            changedValue,
        );
    }

    learnMore(e) {
        if (window.com?.mb?.waffle?.eatWaffle) {
            window.com.mb.waffle.eatWaffle(1);
            e.preventDefault();
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
            this.setState({ waffled: true });
        }
    }

    checkForPeopleModule(){
        const modules = localStorage.getItem('ModulesData');
        const parsedModules = JSON.parse(modules);
        if (parsedModules !== null && parsedModules !== undefined){
            const hasPeople = parsedModules.find(e => e.name === 'People');
            if(hasPeople !== undefined){
                return true; 
            }
        } 
        return false; 
    }

    render() {
        let chMSStatus; 
        const inactiveChMS = (
            <div className="inactive-chms general-section module-display-settings-list">
                <h2 className="section-name">{i18n.t('integrations.chms.inactive-header')}</h2>
                <p>{i18n.t('integrations.chms.inactive-subtitle')}</p>
                <img width={204} height={65} src={ShelbyIcon} alt="ShelbyNext" />
                <img width={204} height={65} src={F1GoIcon} alt="FellowshipOne Go" />
                <img width={204} height={65} src={SCCRMIcon} alt="SimpleChurchCRM" />
                <img className="EasyTitheLogo" width={204} height={65} src={ETIcon} alt="EasyTithe Plus" />
                <img width={204} height={65} src={COOnlineIcon} alt="ChurchOfficeOnline" />
                <img width={204} height={65} src={ElexioIcon} alt="Elexio" />
                <div className="btn-wrapper btn-wrapper__status text-center">
                    {/* eslint-disable-next-line react/button-has-type */}
                    {this.state?.waffled ? <button className="btn btn-success btn-sm"><SuccessCheck /></button> : <a onClick={(e) => { return this.learnMore(e); }} href="mailto:support@ministryone.com?subject=I'd%20like%20more%20info%20on%20ChMSes%20for%20MinistryOne&body="><button className="btn btn-primary btn-sm">{i18n.t('integrations.chms.learn')}</button></a>}
                </div>
                <p className="helpline">
                    {i18n.t('integrations.chms.tagline')}
                    <a href="mailto:support@ministryone.com?subject=I%20have%20a%20supported%20ChMS%20but%20it%20isn't%20showing%20in%20MinistryOne&body=">{i18n.t('integrations.chms.tagline-support')}</a>
                </p>
            </div>
        );
        const activeChMS = (
            <div className="active-chms general-section module-display-settings-list">
                <h2 className="section-name">{i18n.t('integrations.chms.active-header')}</h2>
                <p>{i18n.t('integrations.chms.active-subtitle')}</p>
                <HorizontalFormContainer
                    inputClass="module-display-setting__setting"
                    title={i18n.t('integrations.chms.toggle')}
                >
                    <OnOffSwitch
                        id="show-featured"
                        buttonClass="toggle checkbox md-checkbox"
                        isToggleOn={this.props.versions.select.chMSIntegrations}
                        name="chMSIntegrations"
                        onChange={this.updateVersionFromEvent}
                    />
                </HorizontalFormContainer>
                {this.props.projects.data.filter(
                    (project) => { return project.liveVersion; },
                ).length > 0
                && this.props.projects.liveConfig?.app.sccrmDomain?.length === 0
                && this.props.versions.select.chMSIntegrations
            && (
                <div id="integration-help-text" className="integration-help-text">
                    <Exclamation />
                    {i18n.t('integrations.chms.warning')}
                </div>
            )}
            </div>
        );
        
        // created acitve and inactiveChMSAmplify obejcts that utilize existing components to make sure toggle is in correct state but could most likely remove or simplify 
        const activeChMSAmplify = (
            // <div className="active-chms general-section module-display-settings-list">
            <div className="ChmsAmplifyIntegrationToggles">
                <h2 className="section-name">{i18n.t('integrations.chms.active-header')}</h2>
                <p>{i18n.t('integrations.chms.active-subtitle')}</p>
                <HorizontalFormContainer
                    inputClass="module-display-setting__setting-Amplify"
                    title={i18n.t('integrations.chms.toggle')}
                >
                    <OnOffSwitch
                        id="show-featured"
                        buttonClass="toggle checkbox md-checkbox"
                        isToggleOn={true}
                        name="chMSIntegrations"
                        onChange={this.updateVersionFromEvent}
                        disabled={true}
                        
                    />
                </HorizontalFormContainer>
                {this.props.projects.data.filter(
                    (project) => { return project.liveVersion; },
                ).length > 0
                && this.props.projects.liveConfig?.app.sccrmDomain?.length === 0
                && this.props.versions.select.chMSIntegrations
            && (
                <div id="integration-help-text" className="integration-help-text">
                    <Exclamation />
                    {i18n.t('integrations.chms.warning')}
                </div>
            )}
            </div>
        );

        const inactiveChMSAmplify = (
            // <div className="active-chms general-section module-display-settings-list">
            <div className="ChmsAmplifyIntegrationToggles">
                <h2 className="section-name">{i18n.t('integrations.chms.active-header')}</h2>
                <p>{i18n.t('integrations.chms.active-subtitle')}</p>
                <HorizontalFormContainer
                    inputClass="module-display-setting__setting-Amplify"
                    title={i18n.t('integrations.chms.toggle')}
                >
                    <OnOffSwitch
                        id="show-featured"
                        buttonClass="toggle checkbox md-checkbox"
                        isToggleOn={false}
                        name="chMSIntegrations"
                        onChange={this.updateVersionFromEvent}
                        disabled={true}
                        
                    />
                </HorizontalFormContainer>
                {this.props.projects.data.filter(
                    (project) => { return project.liveVersion; },
                ).length > 0
                && this.props.projects.liveConfig?.app.sccrmDomain?.length === 0
                && this.props.versions.select.chMSIntegrations
            && (
                <div id="integration-help-text" className="integration-help-text">
                    <Exclamation />
                    {i18n.t('integrations.chms.warning')}
                </div>
            )}
            </div>
        );
        
        const PeopleModule = this.checkForPeopleModule();
        const isUnity = localStorage.getItem('IsUnity');
        if(isUnity === 'true' && PeopleModule === true){
            chMSStatus = activeChMSAmplify; 
        }
        else if(isUnity === 'false' && this.props.profiles.data.sccrmDomain == null) {
            chMSStatus = inactiveChMS;
        }
        else if(isUnity === 'false' && this.props.profiles.data.sccrmDomain !== null){
            chMSStatus = activeChMS; 
        }
        else if(isUnity === 'true' && PeopleModule === false){
            chMSStatus = inactiveChMSAmplify; 
        }
        else{
            chMSStatus = inactiveChMSAmplify; 
        }

        return (
            <div className='chms-integration-container'>
                {chMSStatus}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChmsIntegration);
